import { cn } from '~/lib/cn';

interface HorizontalAxisProps {
  axisLabels: number[];
}

export const HORIZONTAL_GRID_CLASS = cn(
  'grid-cols-[minmax(var(--spacing-4xl),_1fr)_repeat(6,_1fr)_minmax(var(--spacing-4xl),_1fr)]',
);

export function HorizontalAxis({ axisLabels }: HorizontalAxisProps) {
  return (
    <div className="absolute inset-0 -z-10 grid">
      <div className={cn('grid gap-sm', HORIZONTAL_GRID_CLASS)}>
        <div className="col-span-6 col-start-2 -mx-px grid grid-flow-col border-x-px border-b-px border-emphasis-subtle">
          <div className="absolute top-full pl-px pt-sm text-caption-md text-subtle">
            0
          </div>
          {axisLabels.map((label, index) => {
            if (index === axisLabels.length - 1) {
              return null;
            }

            return (
              <div
                key={label}
                className="relative border-x-px border-b-px border-emphasis-subtle"
              >
                <div className="absolute -right-md top-full -mr-px w-xl pt-sm text-center text-caption-md text-subtle">
                  {label}
                </div>
              </div>
            );
          })}
          <div className="relative border-x-px border-b-px border-emphasis-subtle">
            <div className="absolute right-0 top-full -mr-px pt-sm text-center text-caption-md text-subtle">
              {axisLabels[axisLabels.length - 1]}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

HorizontalAxis.displayName = 'HorizontalAxis';
